import { HttpClient, HttpEvent, HttpHeaders, HttpParameterCodec, HttpResponse } from '@angular/common/http';
import { Inject, Injectable, Optional } from '@angular/core';
import { Observable } from 'rxjs';
import { BILL_API_BASE_PATH, Configuration, CustomHttpParameterCodec } from '../../shared-api';
import { Sgke342aRequest } from '../models/sgke342a-request';
import { Sgke342aResponse } from '../models/sgke342a-response';

@Injectable({
  providedIn: 'root'
})
export class Sgke343aService {

  protected basePath = 'https://example.swagger.io/api/bill';
  public defaultHeaders = new HttpHeaders();
  public configuration = new Configuration();
  public encoder: HttpParameterCodec;

  constructor(
    protected httpClient: HttpClient,
    @Optional() @Inject(BILL_API_BASE_PATH) basePath: string,
    @Optional() configuration: Configuration
  ) {
    if (configuration) {
      this.configuration = configuration;
    }
    if (typeof this.configuration.basePath !== 'string') {
      if (typeof basePath !== 'string') {
        basePath = this.basePath;
      }
      this.configuration.basePath = basePath;
    }
    this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
  }

  /**
   * 供給停止結果中断API
   *
   * @param {Sgke342aRequest} [sgke342aRequest]
   * @param {'body'} [observe]
   * @param {boolean} [reportProgress]
   * @param {{ httpHeaderAccept?: 'application/json' }} [options]
   * @return {*}  {Observable<Sgke342aResponse>}
   * @memberof Sgke343aService
   */
  public sgke343aPost(sgke342aRequest?: Sgke342aRequest, observe?: 'body', reportProgress?: boolean, options?: { httpHeaderAccept?: 'application/json' }): Observable<Sgke342aResponse>;
  public sgke343aPost(sgke342aRequest?: Sgke342aRequest, observe?: 'response', reportProgress?: boolean, options?: { httpHeaderAccept?: 'application/json' }): Observable<HttpResponse<Sgke342aResponse>>;
  public sgke343aPost(sgke342aRequest?: Sgke342aRequest, observe?: 'events', reportProgress?: boolean, options?: { httpHeaderAccept?: 'application/json' }): Observable<HttpEvent<Sgke342aResponse>>;
  public sgke343aPost(sgke342aRequest?: Sgke342aRequest, observe: any = 'body', reportProgress: boolean = false, options?: { httpHeaderAccept?: 'application/json' }): Observable<any> {

    let headers = this.defaultHeaders;

    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        'application/json'
      ];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' = 'json';
    if (httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType_ = 'text';
    }

    return this.httpClient.post<Sgke342aResponse>(`${this.configuration.basePath}/SGKE343A`,
      sgke342aRequest,
      {
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

}